<template>
  <div class="update-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
        <button
          v-if="!update.public"
          class="global-button-style"
          @click="toPublic('ruleForm')"
        >
          {{ $t("commonMsg.release") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="update"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('update.title')" prop="title">
            <el-input
              v-model="update.title"
              class="fl"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item :label="$t('boox.region')" prop="region">
            <el-radio-group v-model="update.region">
              <el-radio label="1">国内</el-radio>
              <el-radio label="2">国外</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item
            :label="$t('boox.lang')"
            prop="lang"
            v-if="useLang || $route.query.t === 'booxMira'"
          >
            <el-select v-model="update.lang" filterable>
              <el-option
                v-for="(item, key) in langOpt"
                :key="key"
                :label="item"
                :value="key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('update.introduce')">
            <editor
              api-key="j9xdmm7yklb7mhgzd47u5biiqnnx621qcgm9vta30ejwd4ow"
              v-model="update.description"
              :init="{
                branding: false,
                height: 500,
                menubar: true,
                language: 'zh_CN',
                font_formats:
                  '微软雅黑=Microsoft YaHei;黑体=STHeiti;宋体=simsun;仿宋=STFangsong;新宋体=NSimSun;楷体=KaiTi;隶书=LiSu;幼圆=YouYuan;行楷=STXingkai;姚体=FZYaoti;新魏=STXinwei',
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                file_picker_types: 'image media',
                file_picker_callback: handleUpload,
                toolbar:
                  'undo redo | formatselect | bold italic underline forecolor backcolor fontsizeselect | \
                               alignleft aligncenter alignright alignjustify lineheight| \
                               bullist numlist outdent indent | \
                               image media | link unlink | table removeformat',
                quickbars_selection_toolbar:
                  'removeformat |\
                bold italic underline strikethrough |\
                fontsizeselect forecolor backcolor',
              }"
            />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import OSS from "ali-oss";
import Editor from "@tinymce/tinymce-vue";
import langOpt from "./lang.json";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["buckets"]),
    useLang() {
      return [
        "membership-service",
        "starnote-privacy-policy",
        "starnote-service",
        "galaxy-information-checklist",
        "sign-in-activity", //  签到活动说明
        "payment-policy", //  支付政策
        "booxreader-privacy-policy", //  阅读器隐私政策
        "booxreader-service", //  阅读器用户协议
      ].includes(this.$route.query.t);
    },
  },
  components: {
    editor: Editor,
  },
  data() {
    return {
      langOpt: [
        "membership-service",
        "starnote-privacy-policy",
        "starnote-service",
        "galaxy-information-checklist",
        "sign-in-activity", //  签到活动说明
        "payment-policy", //  支付政策
        "booxreader-privacy-policy", //  阅读器隐私政策
        "booxreader-service", //  阅读器用户协议
      ].includes(this.$route.query.t)
        ? {
            zh: "\u7b80\u4f53\u4e2d\u6587",
            zhTW: "\u7e41\u4f53\u4e2d\u6587",
            en: "\u82f1\u6587",
          }
        : langOpt,
      update: {
        title: "",
        description: "",
        version: this.$route.query.t,
        lang: "zh",
        public: 0,
      },
      isSave: false,
      rules: {
        title: [
          {
            required: true,
            message: this.$t("update.inputTitle"),
            trigger: "blur",
          },
        ],
      },
      resimg: "",
      resVideo: "",
    };
  },
  methods: {
    handleUpload(callback, value, meta) {
      if (meta.filetype == "media") {
        // 上传视频
        //创建一个隐藏的type=file的文件选择input
        let input = document.createElement("input"); //创建一个隐藏的input
        input.setAttribute("type", "file");
        input.onchange = async (e) => {
          let file = e.target.files[0]; //选取第一个文件
          await this.uploadFile(file, "media"); // 上传视频拿到url
          callback(this.resVideo);
        };
        //触发点击
        input.click();
      } else if (meta.filetype == "image") {
        // 上传图片
        let input = document.createElement("input"); //创建一个隐藏的input
        input.setAttribute("type", "file");
        input.onchange = async (e) => {
          let file = e.target.files[0]; //选取第一个文件
          await this.uploadFile(file, "image"); // 上传视频拿到url
          callback(this.resimg);
        };
        //触发点击
        input.click();
      }
    },
    async uploadFile(file, type) {
      console.log(this.buckets, "pzzzz");
      let bucket = this.buckets["onyx-static"].bucket;
      let fileObj = await this.uploadOss(file, bucket, "neocloud_admin");

      if (type == "image") {
        this.resimg = fileObj.url;
      } else if (type == "media") {
        this.resVideo = fileObj.url;
      }
    },

    getAppDetails() {
      this.$http.getUpdateDetails(this.$route.query.id).then((res) => {
        this.update = Object.assign({}, res.data);
      });
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.update.public = 0;
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    toPublic(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.update.public = 1;
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    async create() {
      if (this.$route.query.t === "booxMira") {
        this.update.lang = this.update.lang.split("_")[0];
      } else if (!this.useLang) {
        delete this.update.lang;
      }
      this.$http.createUpdate(this.update).then((res) => {
        this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        this.$router.back();
      });
    },

    async publicUpdate() {
      this.$http.publicUpdate(this.update).then((res) => {
        this.elMsg(this.$t("alertMsg.publicSuccess"), "success");
        this.$router.back();
      });
    },

    async edit() {
      this.$http.putUpdate(this.$route.query.id, this.update).then((res) => {
        this.elMsg(this.$t("alertMsg.editSuccess"), "success");
      });
    },

    uploadOss(file, bucket, key) {
      return new Promise(async (resolve, reject) => {
        try {
          let sts = await this.$http.aliyunSts();
          let region = this.buckets["onyx-static"].region;
          let client = await new OSS({
            region,
            accessKeyId: sts.data.AccessKeyId,
            accessKeySecret: sts.data.AccessKeySecret,
            stsToken: sts.data.SecurityToken,
            bucket,
            secure: true,
          });
          let coverData = await client.multipartUpload(
            `${key}/${file.name}`,
            file,
            {
              progress: (p, cpt, res) => {
                this.progress = Number((p * 100).toFixed(2));
              },
            }
          );

          resolve({
            key: coverData.name,
            bucket,
            name: file.name,
            url: coverData.res.requestUrls[0].split("?")[0],
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getAppDetails();
  },
};
</script>

<style lang="scss">
.update-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .update-import-btn {
        margin-top: 10px;
      }
      .update-upload-progress {
        display: flex;
        align-items: center;
        > .el-progress__text {
          /* width: 100px; */
        }
      }
    }
  }
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label,
.el-form-item--small .el-form-item__content {
  line-height: 24px;
}
.ql-editor {
  height: 450px;
}
</style>
